import { getBalance } from '../utils/solana'; // For Solana balance fetching
import { getBalanceEthereum, getBalanceBase, getBalanceArbitrum, getBalanceBNB, getBalanceOptimism } from '../utils/ethereum'; // Updated import

const balance = async (connectedNetwork: 'ethereum' | 'solana' | 'base' | 'arbitrum' | 'bnb' | 'optimism' | null): Promise<string[]> => {
  // Mapping networks to their respective native token names
  const networkToToken: Record<string, string> = {
    ethereum: 'ETH',
    base: 'ETH',
    arbitrum: 'ETH',
    bnb: 'BNB',
    optimism: 'ETH',
    solana: 'SOL',
  };

  if (connectedNetwork === 'ethereum' || connectedNetwork === 'base' || connectedNetwork === 'arbitrum' || connectedNetwork === 'bnb' || connectedNetwork === 'optimism') {
    // EVM compatible networks
    if (typeof window.ethereum !== 'undefined') {
      const accounts = await window.ethereum.request({ method: 'eth_accounts' });

      if (accounts.length === 0) {
        return ['No Ethereum account connected. Please connect your wallet.'];
      }

      // Determine the balance fetching method based on the network
      const address = accounts[0];
      let balance;

      switch (connectedNetwork) {
        case 'ethereum':
          balance = await getBalanceEthereum(address); // Fetch Ethereum balance
          break;
        case 'base':
          balance = await getBalanceBase(address); // Fetch Base balance
          break;
        case 'arbitrum':
          balance = await getBalanceArbitrum(address); // Fetch Arbitrum balance
          break;
        case 'bnb':
          balance = await getBalanceBNB(address); // Fetch BNB balance
          break;
        case 'optimism':
          balance = await getBalanceOptimism(address); // Fetch Optimism balance
          break;
        default:
          return ['⚠️ Unsupported network.'];
      }

      const token = networkToToken[connectedNetwork]; // Get the native token for the connected network
      return [`🔎 ${connectedNetwork.charAt(0).toUpperCase() + connectedNetwork.slice(1)} Wallet Balance: ${balance.toFixed(4)} ${token}`];
    } else {
      return ['No Ethereum wallet found. Please install MetaMask.'];
    }
  }

  if (connectedNetwork === 'solana') {
    // Check if Solana is connected
    if (window.solana?.publicKey) {
      try {
        const pubkey = window.solana.publicKey.toString();
        const solBalance = await getBalance(pubkey); // Fetch Solana balance
        return [`🔎 Solana Wallet Balance: ${solBalance.toFixed(4)} SOL`];
      } catch (err: any) {
        return ['Failed to fetch Solana balance.', err.message || String(err)];
      }
    } else {
      return ['No Solana wallet found. Please install Phantom or Sollet.'];
    }
  }

  // If no wallet is connected
  return ['No wallet connected. Please connect a wallet first.'];
};

export default balance;
